export class DraftEmailTicketConstants {
    public static ERROR_MESSAGE = {
        'must_be_email': 'Please be sure to use a valid email format'
    };
    public static CONFIG = {
        removePlugins: ['MediaEmbed'],
        toolbar: ['heading', '|', 'bold', 'italic', '|', 'undo', 'redo', 'link']
    };
    public static EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    public static RESOLVED = {"id":25, "value":"Resolved"};
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/draft-email-ticket.constants.ts